import React from 'react';
import {
  ContainerFooter,
  ContainerFooterColEnd,
  ContainerFooterColStart,
  ParFooter,
} from './components';
import LogoLabel from 'components/logo-label';

const Footer = () => {
  return (
    <ContainerFooter>
      <ContainerFooterColStart>
        <LogoLabel />
        <ParFooter>©2025 Acton NGA School</ParFooter>
      </ContainerFooterColStart>
      <ContainerFooterColEnd>
        <ParFooter>Non-Discrimination Policy</ParFooter>
        <ParFooter widthCol={80}>
          Notice of Nondiscriminatory Policy as to Students: Acton NGA School
          admits students of any race, color, national and ethnic origin to all
          the rights, privileges, programs, and activities generally accorded or
          made available to students via online school presence. It does not
          discriminate on the basis of race, color, national and ethnic origin
          in administration of its educational policies, admissions policies,
          scholarship and loan programs, and athletic and other
          school-administered programs.
        </ParFooter>
      </ContainerFooterColEnd>
    </ContainerFooter>
  );
};

export default Footer;
